import script from "./Result.vue?vue&type=script&setup=true&lang=ts"
export * from "./Result.vue?vue&type=script&setup=true&lang=ts"

import "./Result.vue?vue&type=style&index=0&id=87745a60&lang=less&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-87745a60"]])

export default __exports__